import React from "react";

const OtherSVG: React.FunctionComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <rect width="24" height="24" rx="12" fill="#E5E8E9" />
    <path
      d="M11.992 15.125c.88 0 1.64.762 1.64 1.64 0 .909-.76 1.641-1.64 1.641-.908 0-1.64-.732-1.64-1.64 0-.88.732-1.641 1.64-1.641Zm0-4.688c.88 0 1.64.762 1.64 1.641 0 .908-.76 1.64-1.64 1.64-.908 0-1.64-.732-1.64-1.64 0-.879.732-1.64 1.64-1.64Zm1.64-3.046c0 .908-.76 1.64-1.64 1.64-.908 0-1.64-.732-1.64-1.64 0-.88.732-1.641 1.64-1.641.88 0 1.64.762 1.64 1.64Z"
      fill="#1D2948"
    />
  </svg>
);

export default OtherSVG;
